import {get} from 'lodash-es'
import request, {METHODS} from '@/api'
import UrlConfig from '@/api/UrlConfigs'

/**
 * 获取枚举
 */
export const getEnumList = (path: string) => {
  return request(`${UrlConfig.PlusClueWeb.GetPlusEnums}${path}`, {
    method: METHODS.GET,
  })
}

/**
 * 获取渠道分类树
 */
export const getChannelCategoryTree = (data = {}) => {
  return request(UrlConfig.PlusClueWeb.ChannelCategoryTree, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 渠道分类 -- 根据ID查询
 */
export const getChannelCategory = (id) => {
  return request(UrlConfig.PlusClueWeb.GetChannelCategory + id, {
    method: METHODS.GET
  })
}

/**
 * 渠道分类 -- 添加
 */
export const channelCategoryInsert = (data: any) => {
  return request(UrlConfig.PlusClueWeb.ChannelCategoryInsert, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 渠道分类 -- 编辑
 */
export const channelCategoryUpdateById = (data: any) => {
  return request(UrlConfig.PlusClueWeb.ChannelCategoryUpdateById, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 渠道分类 -- 批量编辑状态
 */
export const categoryBatchUpdateStatus = (ids: any[], enabled: boolean) => {
  return request(UrlConfig.PlusClueWeb.ChannelCategoryBatchUpdateStatus, {
    method: METHODS.POST,
    data: {
      ids,
      enabled
    },
  })
}

/**
 * 渠道 - 列表
 */
export const findChannelPage = params => {
  return request(UrlConfig.PlusClueWeb.ChannelPage, {
    method: METHODS.POST,
    ...params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return {records, total}
  })
}

/**
 * 渠道 - 新增
 */
export const channelLibrarySave = (params: any) => {
  return request(UrlConfig.PlusClueWeb.ChannelSave, {
    method: METHODS.POST,
    ...params,
  })
}

/**
 * 渠道 - 查询详情
 */
export const findChannelById = (id: any, params: Record<string, any> = {}) => {
  return request(UrlConfig.PlusClueWeb.GetChannelById + id, {
    method: METHODS.GET,
    params: params
  })
}

export const channelChangeState = (path: string) => {
  return request(UrlConfig.PlusClueWeb.ChannelChangeState + path , {
    method: METHODS.POST,
  })
}

/**
 * 渠道修改日志 - 列表
 */
export const findChannelLogPage = (params) => {
  return request(UrlConfig.PlusClueWeb.ChannelLogPage, {
    method: METHODS.POST,
    ...params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return {records, total}
  })
}

/**
 * 渠道标记 - 列表
 */
export const getChannelMarkListByChannelId = (id: string | number) => {
  return request(UrlConfig.PlusClueWeb.ChannelMarkListByChannelId + id, {
    method: METHODS.GET,
  })
    .then(resp => {
      return resp
    })
}

/**
 * 渠道标记 - 保存
 */
export const channelMarkSave = (params = {}) => {
  return request(UrlConfig.PlusClueWeb.ChannelMarkSave, {
    method: METHODS.POST,
    ...params,
  })
}

/**
 * 渠道标记 - 编辑
 */
export const channelMarkUpdateById = (params = {}) => {
  return request(UrlConfig.PlusClueWeb.ChannelMarkUpdateById, {
    method: METHODS.POST,
    ...params,
  })
}

/**
 * 军种 -- 列表
 */
export const channelTypeList = (data = {}) => {
  return request(UrlConfig.PlusClueWeb.ChannelTypeList, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 获取字典
 */
export const getDictServer = ({code = undefined, key, enable = true, ...rest}) => {
  return request(UrlConfig.PlusProductWeb.GetDataDictionaryList, {
    data: {code, parentKey: key, enabled: enable, ...rest},
    method: METHODS.POST,
  })
    .then(resp => {
      return resp
    })
}

/**
 * 渠道库 - 编辑-开始流程
 */
export const channelLibraryUpdate = (params: any) => {
  return request('/plus-crm-web/channel/updateById', {
    method: METHODS.POST,
    ...params,
  })
}

/**
 * 渠道库 - 修改状态
 */
export const channelLibraryUpdateStatusById = (path: string) => {
  return request(UrlConfig.PlusCrmWeb.ChannelSwitchChannelState + path, {
    method: METHODS.POST,
  })
}

/**
 * 渠道分类 - tree
 */
export const fetchChannelCategoryTree = (path: string = '') => {
  return request(UrlConfig.PlusCrmWeb.ChannelCategoryTree + path, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}

/**
 * 渠道分类 - 删除/查询
 */
export const channelCategoryOperations = (id: any, method: string = 'GET') => {
  return request(`${UrlConfig.PlusCrmWeb.ChannelCategory}/${id}`, {
    method: METHODS[method],
  })
}

/**
 * 渠道分类 - 新增
 */
export const channelCategorySave = (params: any) => {
  return request(UrlConfig.PlusCrmWeb.ChannelCategory, {
    method: METHODS.POST,
    ...params,
  })
}

/**
 * 渠道分类 - 编辑
 */
export const channelCategoryUpdate = (params: any) => {
  return request(UrlConfig.PlusCrmWeb.ChannelCategoryUpdate, {
    method: METHODS.POST,
    ...params,
  })
}

/**
 * 渠道分类 - 修改状态
 */
export const channelCategoryUpdateStatus = (status: number, params = {}) => {
  return request(UrlConfig.PlusCrmWeb.ChannelCategorySwitchEnabled + status, {
    method: METHODS.POST,
    ...params,
  })
}

export const downloadRelateFiles = () => {
  return request(UrlConfig.PlusCrmWeb.ChannelDownloadRelatedChannelFiles, {
    method: METHODS.GET,
    responseType: 'arraybuffer',
    raw: true,
  }).then((resp: any) => {
    return resp
  })
}

/**
 * 公司list
 */
export const getCompanyList = () => {
  return request(UrlConfig.Caas.GetCompanyBranchList, {
    method: METHODS.POST,
    data: {
      enabled: true,
      orgTypes: ["GROUP", "COMPANY"]
    },
  })
    .then(res => res || [])
}

/**
 * 公司员工list
 */
export const getComanySpecifiedRangeList = (params = {}) => {
  return request(UrlConfig.Caas.EmployeeSearchList, {
    method: METHODS.POST,
    ...params,
  })
    .then(res => res || [])
}

/**
 * 根据公司code获取不同部门岗位
 */
export const getDeptListByCompanyCode = (code: string) => {
  return request(UrlConfig.Caas.DepartmentSearchList, {
    method: METHODS.POST,
    data: {companyIds: [code]},
  })
    .then(res => res || [])
}

/**
 * 根据公司code获取不同员工
 */
export const getEmployeeSearchByOrgIdList = (orgId: string) => {
  return request(UrlConfig.Caas.EmployeeSearchByOrgIdList + orgId, {
    method: METHODS.POST,
    data: []
  })
    .then(res => res || [])
}

/**
 * 获取文件前缀
 */
export const getFileUrlPrefix = () => {
  return request(UrlConfig.File.FetchUnifiedProfile, {
    method: METHODS.GET,
  })
    .then(res => {
      return res || ''
    })
}

/**
 * 下载
 */
export const fileDownLoad = (id: string | number) => {
  return request(`${UrlConfig.File.UploadFile}?path=${id}`, {
    method: METHODS.GET,
  })
    .then(res => {
      return res || ''
    })
}
